export const createCase = {
    organization: null,
    isDrawerOpen: false,
    isOpen: false,
    activeCaseRun: {},
    notesSpecialty: [],
    notesSpecialtyLoading: false
};
